import { Switch } from 'antd';
import styled from 'styled-components/macro';

export default function SwitchCheck(props: any) {
  const onChange = (val: boolean) => {
    props.setFieldValue(props.name, val);
  };
  return (<Switch size="small" checked={props.value} onChange={onChange} />);
}
